import type { LeadObject } from '../api/types';
import { propertyTypeLabels } from '../owners/labels';

// Technische Hinweise der KI im Fließtext („Da nur die Seite des Mitarbeiters vorlag, …“) – die Herkunft steht als Hinweis
// daneben, im Text verwirren sie den Makler (Einwand Manfred 12.10.2026, OFFENE_FRAGEN B-28).
const metaSentence = /(Seite des Mitarbeiters|Bestätigungen des Mitarbeiters|Aussagen des Mitarbeiters abgeleitet|nur die Mitarbeiterstimme|nur der Mitarbeiter zu hören)/i;

// cleanAiText: KI-Text ohne Meta-Sätze und ohne doppelte Satzpunkte.
export function cleanAiText(text?: string | null): string {
  const t = (text ?? '').replace(/(?<!\.)\.\.(?!\.)/g, '.').trim();
  const sentences = t.split(/(?<=[.!?])\s+/).filter((s) => s && !metaSentence.test(s));
  return sentences.join(' ').trim();
}

const num = new Intl.NumberFormat('de-DE', { maximumFractionDigits: 0 });

// objectFacts: Hauptobjekt in einer Zeile – „Grundstück · 1.300 m² Grundstück · Baujahr 1975“ und die Preisvorstellung.
export function objectFacts(o?: LeadObject | null): { object: string; price: string } {
  if (!o) return { object: '', price: '' };
  const parts = [
    o.property_subtype || propertyTypeLabels[o.property_type] || '',
    o.living_area_sqm ? `${num.format(o.living_area_sqm)} m² Wohnfläche` : '',
    o.plot_area_sqm ? `${num.format(o.plot_area_sqm)} m² Grundstück` : '',
    o.rooms ? `${num.format(o.rooms)} Zimmer` : '',
    o.year_built ? `Baujahr ${o.year_built}` : '',
  ].filter(Boolean);
  return { object: parts.join(' · '), price: o.price_expectation_eur ? `${num.format(o.price_expectation_eur)} €` : '' };
}
